module.exports = __webpack_public_path__ + "img/xunshijilu.fea79225.png";